module.exports = __webpack_public_path__ + "assets/img/c4.bcaa288b.png";